import { Component, inject, input, signal, computed } from '@angular/core';

import { BucketEndpoint } from '@api/services/bucket-endpoint';

@Component({
  standalone: true,
  selector: 'app-image',
  templateUrl: './image.component.html',
  host: { class: 'absolute inset-0' }
})
export class ImageComponent {
  alt = input.required<string>();
  id = input.required<string>();
  name = input.required<string>();

  private readonly bucketEndpoint = inject(BucketEndpoint);

  private readonly defaultSrc = './assets/img/image-not-found.png';
  private readonly failed = signal(false);

  readonly imageUrl = computed(() => {
    if (this.failed() || !this.hasValidImage()) {
      return this.defaultSrc;
    }

    return this.bucketEndpoint.getParticipationPhotoLink(this.id(), this.name());
  });

  private hasValidImage(): boolean {
    return !!this.id() && !!this.name();
  }

  handleImageError(): void {
    this.failed.set(true);
  }
}
